<template>
  <div class="home">
    <img width="30%" alt="Lynx logo" class="login_img" src="../assets/img/logo.png">
    <Login/>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/LoginComp.vue'

export default {
  name: 'LoginView',
  components: {
    Login
  }
}
</script>

<style scoped>
.home {
    background: linear-gradient(rgb(146, 54, 54), rgb(87, 41, 41));
    height: 100vh; /* Ceci définit la hauteur à 100% de la hauteur de la fenêtre de visualisation */
}
@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); } /* Augmente la taille de 3% */
}
.login_img {
  animation: pulse 1s infinite; /* Appliquez l'animation ici */
}
</style>
